import React from "react";
import facebook from "src/assets/images/facebook.svg";
import insta from "src/assets/images/insta.svg";
import linkedin from "src/assets/images/linkedin.svg";
import twitter from "src/assets/images/square-x-twitter.svg";
import threads from "src/assets/images/threads.svg";

const SocialIcons = ({ instaLink, twitterLink, faceBookLink, linkedLink, threadsLink }) => {
  const IconsData = [
    { url: facebook, name: "facebook", link: faceBookLink },
    { url: insta, name: "insta", link: instaLink },
    { url: linkedin, name: "linkedin", link: linkedLink },
    { url: twitter, name: "twitter", link: twitterLink },
    { url: threads, name: "threads", link: threadsLink },
  ];

  return (
    <div className="flex flex-row gap-2">
      {IconsData.filter(item => item.link).map((item, index) => (
        <a
          key={index}
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 flex items-center justify-center"
        >
          <img
            src={item.url}
            alt={item.name}
            className={
              item.name === "twitter" || item.name === "threads"
                ? "w-7 h-7 object-contain"
                : "w-8 h-8 object-contain"
            }
          />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
